import { useState } from 'react';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import CloseIcon from '@material-ui/icons/Close';
import CheckIcon from '@material-ui/icons/Check';
import MoreVertIcon from '@material-ui/icons/MoreVert';

import Editor from 'react-simple-code-editor';
import { highlight, languages } from 'prismjs/components/prism-core';

import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-javascript';
import 'prismjs/themes/prism.css';

import { getCapabilities } from 'homey-lib';

import TableWithSearch from './TableWithSearch';

function Yes() {
  return <CheckIcon style={{ color: 'green' }} />;
}

function No() {
  return <CloseIcon style={{ color: 'red' }} />;
}

const capabilities = getCapabilities();

function CapabilityReference() {
  const [dialog, setDialog] = useState({ open: false, title: '', content: '' });
  const [filterValue, setFilterValue] = useState('');

  function handleClose() {
    setDialog({ open: false, title: '', content: '' });
  }

  return (
    <>
      <TableWithSearch
        filter={filterValue}
        onSearch={(capabilitiesFilter) => setFilterValue(capabilitiesFilter)}
      >
        <TableHead>
          <TableRow>
            <TableCell></TableCell>
            <TableCell>ID</TableCell>
            <TableCell>Name</TableCell>
            <TableCell>Compatibility</TableCell>
            <TableCell>Type</TableCell>
            <TableCell>Units</TableCell>
            <TableCell>Getable</TableCell>
            <TableCell>Setable</TableCell>
            <TableCell>Insights</TableCell>
            <TableCell>Quick Action</TableCell>
            <TableCell>Flow</TableCell>
            <TableCell>UI Component</TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {Object.keys(capabilities)
            .filter((capabilityId) => {
              const capability = capabilities[capabilityId];
              return (JSON.stringify(capability) + capabilityId)
                .toLowerCase()
                .includes(filterValue.toLowerCase());
            })
            .map((capabilityId) => {
              const capability = capabilities[capabilityId];
              return (
                <TableRow key={capabilityId}>
                  <TableCell><img className="CapabilityIcon" src={`${process.env.PUBLIC_URL}/icons/${capabilityId}.svg`} alt="" /></TableCell>
                  <TableCell className="CapabilityType">{capabilityId}</TableCell>
                  <TableCell>{capability.title.en}</TableCell>
                  <TableCell><code>{capability.minCompatibility ? '>=' + capability.minCompatibility : ''}</code></TableCell>
                  <TableCell className={`CapabilityType CapabilityType-${capability.type}`}>
                    {capability.type}
                  </TableCell>
                  <TableCell><code>{capability.units ? capability.units.en ?? capability.units : ''}</code></TableCell>
                  <TableCell>{capability.getable ? <Yes /> : <No />}</TableCell>
                  <TableCell>{capability.setable ? <Yes /> : <No />}</TableCell>
                  <TableCell>{capability.insights ? <Yes /> : <No />}</TableCell>
                  <TableCell>{capability.uiQuickAction ? <Yes /> : <No />}</TableCell>
                  <TableCell>{capability.$flow ? <Yes /> : <No />}</TableCell>
                  <TableCell>{capability.uiComponent}</TableCell>
                  <TableCell>
                    <IconButton
                      onClick={() => {
                        setDialog({
                          open: true,
                          title: `Capability — ${capabilityId}`,
                          content: JSON.stringify(capability, false, 2),
                        });
                      }}
                    >
                      <MoreVertIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              );
            })}
        </TableBody>
      </TableWithSearch>

      <Dialog open={dialog.open} onClose={handleClose} fullWidth maxWidth={false}>
        <DialogTitle>{dialog.title}</DialogTitle>
        <DialogContent>
          <Editor
            value={dialog.content}
            highlight={(code) => highlight(code, languages.js)}
            style={{
              fontFamily: '"Fira code", "Fira Mono", monospace',
              fontSize: 12,
              outline: 'none',
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Close</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default CapabilityReference;
